import React from "react";
import { checkTextTranslation, getObject, setObject, translate } from "../../utils/useful";
import SelectInput from "./SelectInput";
import SwitchInput from "./SwitchInput";
import FormViewer from "../FormViewer";
import FixedView from "../FixedView";

// used for making the prop types of this component
// import PropTypes from "prop-types";

class DimensionsInput extends React.Component {
    state = {
        value: '',
        showValue: '',
        headers: [
            {
                key: 'length.value', type: 'NumberInput', col: '9', information: {
                    label: "{{lang}}Length", placeholder: "{{lang}}Length", required: false,
                    unit: { key: 'length.unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}type', defaultValue: 'in', type: 'local', items: [{ value: 'in', title: 'in' }, { value: 'm', title: 'm' }, { value: 'cm', title: 'cm' }, { value: 'ft', title: 'ft' }], placeholder: '{{lang}}Unit', required: true }, showMain: true },
                }
            },

            {
                key: 'width.value', type: 'NumberInput', col: '9', information: {
                    label: "{{lang}}Width", placeholder: "{{lang}}Width", required: false,
                    unit: { key: 'width.unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}type', defaultValue: 'in', type: 'local', items: [{ value: 'in', title: 'in' }, { value: 'm', title: 'm' }, { value: 'cm', title: 'cm' }, { value: 'ft', title: 'ft' }], placeholder: '{{lang}}Unit', required: true }, showMain: true },
                }
            },

            {
                key: 'height.value', type: 'NumberInput', col: '9', information: {
                    label: "{{lang}}Height", placeholder: "{{lang}}Height", required: false,
                    unit: { key: 'height.unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}type', defaultValue: 'in', type: 'local', items: [{ value: 'in', title: 'in' }, { value: 'm', title: 'm' }, { value: 'cm', title: 'cm' }, { value: 'ft', title: 'ft' }], placeholder: '{{lang}}Unit', required: true }, showMain: true },
                }
            },

            {
                key: 'weight.value', type: 'NumberInput', col: '9', information: {
                    label: "{{lang}}Weight", placeholder: "{{lang}}Weight", required: false,
                    unit: { key: 'weight.unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}type', defaultValue: 'lb', type: 'local', items: [{ value: 'lb', title: 'lb' }, { value: 'oz', title: 'oz' }, { value: 'g', title: 'g' }, { value: 'kg', title: 'kg' }], placeholder: '{{lang}}Unit', required: true }, showMain: true },
                }
            },


        ]
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ show: true })

        }, 1);
    }

    componentDidUpdate(prevProps) {

    }






    openfixView = () => {

        this.fixView.showView()
        setTimeout(() => {
            this.fixView.getBounding()
        }, 1);

    }

    // changeFixedValue = (key, value, extra) => {

    //     this.props.changeValue(key, value, extra)
    //     // this.setState({ value: value, showValue: this.changeToPriceValue(value) })
    //     setTimeout(() => {
    //         this.fixView.getBounding()
    //     }, 1);
    // }

    liveChange = (data, init, key, value, extra, full) => {

        console.log("data",data)
        console.log("this.props.header?.key",this.props.header?.key)

        this.props.changeValue(this.props.header?.key, data, this.props.extra)
    }




    render() {

        let showValue = null
        let data = this.props.data
        let length = (data?.length?.value ? (String(data?.length?.value) + " " + (data?.length?.unit ?? 'in')) : "-")
        let width = (data?.width?.value ? (String(data?.width?.value) + " " + (data?.width?.unit ?? 'in')) : "-")
        let height = (data?.height?.value ? (String(data?.height?.value) + " " + (data?.height?.unit ?? 'in')) : "-")
        let weight = (data?.weight?.value ? (String(data?.weight?.value) + " " + (data?.weight?.unit ?? 'lb')) : null)



        // if (data?.length?.value || data?.width?.value || data?.height?.value || data?.weight?.value) {

        //     showValue = (data.length?.value ? (String(data.length?.value) + " " + (data.length?.unit ?? 'in')) : "-")

        //     showValue = showValue + ' ✕ ' + (data.width?.value ? (String(data.width?.value) + " " + (data.width?.unit ?? 'in')) : "-")
        //     showValue = showValue + ' ✕ ' + (data.height?.value ? (String(data.height?.value) + " " + (data.height?.unit ?? 'in')) : "-")

        //     showValue = showValue + ' ' + (data.weight?.value ? (String(data.weight?.value) + (data.weight?.unit ?? 'lb')) : '')

        // }




        return (
            <div className='mt-0 w-100 flexc flex-1' ref={el => this.firstCurrentNode = el}>

                <>
                    <div className="w-100 flex-1 flexcb" onClick={() => this.openfixView()}>
                        {(data?.length?.value || data?.width?.value || data?.height?.value || data?.weight?.value) ? (
                            <div className="flexc w-100">

                                <p className="w-100" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>
                                    {(data?.length?.value || data?.width?.value || data?.height?.value) && (
                                        <>
                                            {length} <span className="text-smallest"> ✕ </span>{width} <span className="text-smallest"> ✕ </span>{height}<span> </span>
                                        </>
                                    )}

                                    {weight != null && (
                                        <span>{weight}</span>
                                    )}
                                </p>


                            </div>
                        ) : (
                            <p className="placeholder"> {this.props.information?.placeholder ?? translate('Value ...')}</p>
                        )}

                    </div>
                    {this.state.show && (
                        <FixedView ref={el => this.fixView = el} nodeRef={this.firstCurrentNode} showFocus={false} fixed={this.state.fixed} topOffset={7} bottomOffset={22} xOffset={0} zIndex={20}  width={240} >
                            <div className=" px-2 pt-3 pb-1  d-flex flex-column w-100 " style={{ boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 10 }}>

                                <FormViewer ref={el => this.form = el} initData={this.props.data} liveChange={this.liveChange} headers={this.state.headers} formClass="bordered-form " inputClass={'bordered-input'} nopadding={true} />

                            </div>

                        </FixedView>
                    )}

                </>



            </div>
        );
    }
}

export default DimensionsInput;
